import React, { useEffect, useState } from "react";
import DataListTitle from "../components/DataList/DataListTitle";
import styled from "styled-components";
import { DateRangePicker } from "rsuite";
import { Input } from "rsuite";
import { Button } from "@mui/material";
import { styled as style } from "@mui/material/styles";
import { TagPicker } from "rsuite";
import subDays from "date-fns/subDays";
import addDays from "date-fns/addDays";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import addMonths from "date-fns/addMonths";
import "rsuite/dist/rsuite.css";
import HistoryListBody from "../components/DataList/HistoryListBody";
import { useQuery, useQueryClient } from "react-query";
import { useForm, Controller } from "react-hook-form";
import Footer from "../components/Footer";
import { Pagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "../libraries/ApiClient";
import dayjs from "dayjs";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 95%;
  height: calc(100% - 50px);
  color: #252525;
  position: relative;
  h1 {
    line-height: 20px;
  }
  .search {
    width: 100%;
    .searchTop {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      position: relative;
      .left {
        display: flex;
        .otherCondition {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          border: 1px solid #f2f2f2;
          border-radius: 5px;
          font-size: 14px;
          cursor: pointer;
          margin-left: 16px;
        }
      }
    }
    .searchBottom {
      border: 1px solid #f2f2f2;
      width: 100%;
      padding: 8px;
      margin-bottom: 8px;
      border-radius: 5px;
      display: ${({ isOpen }) => (isOpen ? `flex` : `none`)};
      /* position: absolute; */
      z-index: 1;
      flex-direction: column;
      .top {
        display: flex;
        justify-content: space-between;
        .basicInformation {
          width: 49%;
        }
        .caseStatus {
          width: 49%;
        }
      }
      .btn {
        display: flex;
        justify-content: end;
      }
    }
  }
  .pagination {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    position: ${({ isOpen }) => (isOpen ? `initial` : `absolute`)};
    bottom: 0px;
  }
  .table {
    width: 100%;
    max-height: calc(100% - 246px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  @media (max-width: 1200px) {
    .table {
      max-height: 100%;
      overflow-y: visible;
    }
    .pagination {
      position: static;
    }
  }
`;

const predefinedBottomRanges = [
  {
    label: "今天",
    value: [new Date(), new Date()],
    closeOverlay: false,
    appearance: "default",
  },
  {
    label: "昨天",
    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    closeOverlay: false,
    appearance: "default",
  },
  {
    label: "近7日",
    value: [subDays(new Date(), 6), new Date()],
    closeOverlay: false,
    appearance: "default",
  },
  {
    label: "近30日",
    value: [subDays(new Date(), 29), new Date()],
    closeOverlay: false,
    appearance: "default",
  },
  {
    label: "本月",
    value: [startOfMonth(new Date()), new Date()],
    closeOverlay: false,
    appearance: "default",
  },
  {
    label: "上月",
    value: [
      startOfMonth(addMonths(new Date(), -1)),
      endOfMonth(addMonths(new Date(), -1)),
    ],
    closeOverlay: false,
    appearance: "default",
  },
  {
    label: "近一年",
    value: [subDays(new Date(), 365), new Date()],
    closeOverlay: false,
    appearance: "default",
  },
];

const CssCancelButton = style(Button)({
  fontSize: 12,
  borderColor: "#057AFF",
  backgroundColor: "#fff",
  padding: "3px 0px",
  "&:hover": {
    borderColor: "#1570EF",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
  ".MuiButton-startIcon": {
    marginRight: "4px",
  },
});

const CssSaveButton = style(Button)({
  fontSize: 12,
  backgroundColor: "#057AFF",
  padding: "4px 0px",
  boxShadow: "none",
  borderColor: "#057AFF",

  "&:hover": {
    backgroundColor: "#1570EF",
    cursor: "pointer",
    boxShadow: "none",
    borderColor: "#057AFF",
  },
});

function HistoryListData({ lineUserId }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState("");
  const [nowPageNumber, setNowPageNumber] = useState(1);
  const [selfIdentities, setSelfIdentities] = useState([]);

  const currentToken = JSON.parse(localStorage.getItem("auth"))?.Token;
  const currentselfIdentities = JSON.parse(
    localStorage.getItem("auth")
  )?.SelfIdentities;

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("auth"))?.Token;
    setToken(token);
    const time = dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss");
    const version = import.meta.env.VITE_VERSION;
    const accountRowId = JSON.parse(localStorage.getItem("auth"))?.AccountRowId;

    if (token === undefined) {
      navigate("/Login");
    }
    apiClient.logOfActionEnterPage(location.pathname, "EnterPage", {
      token,
      lineUserId,
      accountRowId,
      time,
      version,
    });

    setSelfIdentities(JSON.parse(localStorage.getItem("auth"))?.SelfIdentities);
  }, []);

  const { getValues, control, reset } = useForm({
    defaultValues: {
      basic: "",
      case: [],
      date: [],
      transfer: [],
      open: false,
    },
  });

  const handlePageChange = (event, value) => {
    setNowPageNumber(value);
  };

  const sendSearchData = async ({ queryKey }) => {
    const data = {
      Data: {
        CurrentPage: queryKey[2],
        PageSize: 15,
        Search: queryKey[3],
        DateTimeStart: queryKey[4] && queryKey[4][0],
        DateTimeEnd: queryKey[4] && queryKey[4][1],
        StatusList: queryKey[5],
        OriginalOrgCodes: queryKey[6],
      },
    };

    const res = await apiClient.postAes(
      "api/referral/HistoryList/Security",
      data
    );

    if (res?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
      return
    }
    return res?.data;
  };

  const { data, refetch, isLoading } = useQuery(
    [
      "sendSearchData",
      token,
      nowPageNumber,
      getValues("basic"),
      getValues("date"),
      getValues("case"),
      getValues("transfer"),
    ],
    sendSearchData,
    { refetchOnWindowFocus: false, cacheTime: 0 }
  );
  // console.log(data);

  const getHospitalData = async ({ queryKey }) => {
    const data = {
      Data: {},
    };

    const res = await apiClient.postAes("api/referral/GetOrg/Security", data);
    return res?.data;
  };

  const { data: hospitalData } = useQuery(
    ["getHospitalData", token],
    getHospitalData,
    {
      enabled: !!token,
      refetchOnWindowFocus: false,
    }
  );

  const caseStatusData = [
    { label: "病情回饋", value: 10 },
    { label: "轉診回饋", value: 12 },
    { label: "不需IA", value: 9 },
    { label: "取消轉診", value: 11 },
    { label: "不收治", value: 6 },
  ].map((item) => ({ label: item.label, value: item.value }));

  const transferHospitalData = hospitalData?.Data?.Orgs?.map((item) => ({
    label: item.Name,
    value: item.Code,
  }));

  if (isLoading) {
    return <h1>Loading...</h1>;
  }

  return (
    <Container isOpen={open}>
      <DataListTitle />
      <div className="search">
        <div className="searchTop">
          <div className="left">
            <Controller
              control={control}
              name="date"
              render={({ field: { value, onChange } }) => (
                <DateRangePicker
                  placeholder="選擇日期"
                  style={{ zIndex: 1 }}
                  ranges={predefinedBottomRanges}
                  value={value}
                  onChange={onChange}
                  editable={false}
                  onOk={() => {
                    refetch();
                    setNowPageNumber(1);
                  }}
                  onClean={() => {
                    reset();
                  }}
                  inputMode="none"
                  showOneCalendar
                  locale={{
                    sunday: "日",
                    monday: "一",
                    tuesday: "二",
                    wednesday: "三",
                    thursday: "四",
                    friday: "五",
                    saturday: "六",
                    ok: "確認",
                  }}
                />
              )}
            />
            <div
              className="otherCondition"
              onClick={() => {
                setOpen(!open);
              }}
            >
              <i
                className="fa-solid fa-filter"
                style={{ fontSize: "12px" }}
              ></i>
              其他條件
              <i
                className="fa-solid fa-chevron-down"
                style={{ fontSize: "12px" }}
              ></i>
            </div>
          </div>
        </div>
        <div className="searchBottom">
          <div className="top">
            <div className="basicInformation">
              <h1 style={{ padding: "4px" }}>姓名/編號</h1>
              <Controller
                control={control}
                name="basic"
                render={({ field: { value, onChange } }) => (
                  <Input
                    placeholder="輸入關鍵字"
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
            </div>
            <div className="caseStatus">
              <h1 style={{ padding: "4px" }}>收案狀態</h1>
              <Controller
                control={control}
                name="case"
                render={({ field: { value, onChange } }) => (
                  <TagPicker
                    data={caseStatusData}
                    placeholder="選擇狀態"
                    style={{ width: "100%", zIndex: 1 }}
                    value={value}
                    onChange={onChange}
                    searchable={false}
                  />
                )}
              />
            </div>
          </div>
          <div
            className="transferHospital"
            style={{
              display: currentselfIdentities?.length > 0 ? "block" : "none",
            }}
          >
            <h1 style={{ padding: "4px" }}>轉出醫院</h1>
            <Controller
              control={control}
              name="transfer"
              render={({ field: { value, onChange } }) => (
                <TagPicker
                  placeholder="請選擇醫院"
                  data={transferHospitalData || []}
                  style={{ width: "100%", zIndex: 1 }}
                  value={value}
                  onChange={onChange}
                  inputMode={"none"}
                  searchable={false}
                />
              )}
            />
          </div>
          <div className="btn">
            <CssCancelButton
              size="small"
              variant="outlined"
              style={{ minWidth: "70px", margin: "8px 8px 0px 8px" }}
              onClick={() => {
                reset();
              }}
            >
              重設
            </CssCancelButton>
            <CssSaveButton
              size="small"
              variant="contained"
              style={{ minWidth: "70px", margin: "8px 8px 0px 8px" }}
              onClick={() => {
                refetch();
                setNowPageNumber(1);
                setOpen(false);
              }}
            >
              確認
            </CssSaveButton>
          </div>
        </div>
      </div>
      <div className="table">
        <HistoryListBody data={data?.Data} />
      </div>
      <div className="pagination">
        <Pagination
          count={data?.Data?.PageCount}
          page={nowPageNumber}
          onChange={handlePageChange}
          siblingCount={0}
          boundaryCount={2}
          style={{ padding: "8px 0px" }}
        />
        <Footer />
      </div>
    </Container>
  );
}

export default HistoryListData;
